interface Props {
  onCancel: () => void;
  onConfirm: () => void;
}

export const CancelDialog = ({ onCancel, onConfirm }: Props) => {
  const handleConfirm = () => {
    onConfirm();
  };
  return (
    <div className="flex h-52 w-96 flex-col">
      <p className="text-2xl font-semibold text-black">수정을 중단하시겠습니까?</p>
      <p className="mt-6 flex flex-1 text-lg text-[#3d3d3d]">
        지금 수정을 중단하면 현재 수정한 정보는 변경되지 않습니다. 정말
        중단하시겠습니까?
      </p>
      <div className="flex gap-4">
        <button
          onClick={handleConfirm}
          className="mt-auto flex h-12 w-full flex-1 items-center justify-center rounded  bg-[#F6F8FF] text-base font-medium text-[#475AC1]"
        >
          네, 그만둘게요
        </button>
        <button
          onClick={onCancel}
          className="mt-auto flex h-12 w-full flex-1 items-center justify-center rounded bg-[#475AC1] text-base font-medium text-white"
        >
          계속할게요
        </button>
      </div>
    </div>
  );
};
